import React from 'react';
import { useIntl } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus';
import { TypedMemo } from '../../../common/types';
import { SMLButton } from '../../../common/views/SMLButton/SMLButton';
import { mailboxMessages as messages } from './mailboxMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Mailboxes card; each part uses its own slice of it */
import styles from './Mailboxes.module.scss';

interface MailboxAddRowProps {
  /** The mailboxes that still fit on the plan (1 or more). */
  room: number;
  onConnect: () => void;
}

/** "Connect another mailbox" (design outreach-v2 q1): a dashed row while the plan has room. */
const MailboxAddRowComponent: React.FC<MailboxAddRowProps> = ({ room, onConnect }) => {
  const intl = useIntl();
  return (
    <div className={styles.add} data-testid="mailbox-add">
      <span className={styles.addIcon} aria-hidden="true">
        <FontAwesomeIcon icon={faPlus} />
      </span>
      <div className="flex-grow-1">
        <b className="d-block">{intl.formatMessage(messages.addTitle)}</b>
        <small className="text-body-secondary">{intl.formatMessage(messages.addBody, { count: room })}</small>
      </div>
      <SMLButton size="sm" color="primary" omitCap onClick={onConnect} testID="mailbox-connect">
        {intl.formatMessage(messages.addButton)}
      </SMLButton>
    </div>
  );
};

export const MailboxAddRow = TypedMemo(MailboxAddRowComponent);
